module.exports = __webpack_public_path__ + "static/media/relativoMarcado.0ba5a939.png";